<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

	page: {
		title: 'Новый аккаунт',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect },

	data() {
        return {
			title: 'Новый аккаунт',
			items: [],
            account_uuid: '',
            trackBy: 'id',
            number: null,
            credit: 0,
            company: null,
            company_options: [],
            initCompany: [],
            user: null,
            users_options: [],
            initUser: [],
            tariff: null,
            tariffs_options: [],
            initTariff: [],
            status: null,
            initStatus: [],
            status_options: [
                { id:'active',   name:'Активен' },
                { id:'wait',     name:'Ожидает активации' },
                { id:'disabled', name:'Отключен' },
                { id:'blocked',  name:'Заблокирован' },
            ],
            payment_type: null,
            initPaymentType: [],
            payment_type_options: [
                { id:'before', name:'Предоплатный' },
                { id:'after',  name:'Постоплатный' },
            ],
		}
	},

    watch: {
        initPaymentType: {
            immediate: true,
            handler(values) {
                this.payment_type = this.payment_type_options.filter(x => values.includes(x[this.trackBy]));
                this.payment_type = this.payment_type[0];
            }
        },
        initUser: {
            immediate: true,
            handler(values) {
                this.user = this.users_options.filter(x => values.includes(x[this.trackBy]));
                this.user = this.user[0];
            }
        },
        initCompany: {
            immediate: true,
            handler(values) {
                this.company = this.company_options.filter(x => values.includes(x[this.trackBy]));
                this.company = this.company[0];
            }
        },
        initTariff: {
            immediate: true,
            handler(values) {
                this.tariff = this.tariffs_options.filter(x => values.includes(x[this.trackBy]));
                this.tariff = this.tariff[0];
            }
        },
        initStatus: {
            immediate: true,
            handler(values) {
                this.status = this.status_options.filter(x => values.includes(x[this.trackBy]));
                this.status = this.status[0];
            }
        }
    },

	computed: {
        account_item(){
            let account = this.$store.getters['accounts/GET_ACCOUNTS_ITEM'];
            return account;
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            let user = session.user ? session.user : null;
            return user;
        },
        company_list_data(){
            return this.$store.getters['companies/GET_COMPANIES_LIST_DATA'];
        },
        users_list_data(){
            return this.$store.getters['users/GET_USERS_LIST_DATA'];
        },
        tariffs_list_data(){
            return this.$store.getters['tariffs/GET_TARIFFS_LIST_DATA'];
        }
	},

	async mounted() {

        this.account_uuid = this.$route.params.account_uuid ? this.$route.params.account_uuid : '';

        let company_data_send = {
            'limit': 2000
        };
        await this.$store.dispatch('companies/FETCH_COMPANIES_LIST', company_data_send);
        this.company_options = this.company_list_data;

        let users_data_send = {
            'limit': 2000
        }
        await this.$store.dispatch('users/FETCH_USERS_LIST', users_data_send);
        this.users_options = this.users_list_data;

        await this.$store.dispatch('tariffs/FETCH_TARIFFS_LIST', {});
        this.tariffs_options = this.tariffs_list_data;

        if(this.account_uuid !== ''){

            this.title = 'Редактирование аккаунта';
            document.title = appConfig.title + ' - ' + 'Редактирование аккаунта';

            let data_send = {
                'uuid' : this.account_uuid,
            }

            await this.$store.dispatch('accounts/FETCH_ACCOUNTS_ITEM', data_send);

            let account = this.account_item;

            this.number  = account.number     ? account.number     : null;
            this.user    = account.user_id    ? account.user_id    : null;
            this.company = account.company_id ? account.company_id : null;
            this.credit  = account.credit     ? account.credit     : null;
            this.status  = account.status     ? account.status     : null;
            this.tariff  = account.tariff_id  ? account.tariff_id  : null;
            this.payment_type = account.payment_type ? account.payment_type : null;

            this.initPaymentType = [this.payment_type];
            this.initUser = [this.user];
            this.initTariff = [this.tariff];
            this.initCompany = [this.company];
            if (this.status !== null) {
                this.initStatus = [this.status];
            }
        }
	},

	methods: {

        async saveUser(){

            if(this.credit === '' || this.credit === null){
                this.credit = 0;
            }

            let data_send = {
                'number'     : this.number,
                'company_id' : this.company && this.company.id ? this.company.id : null,
                'user_id'    : this.user && this.user.id ? this.user.id : null,
                'tariff_id'  : this.tariff && this.tariff.id ? this.tariff.id : null,
                'credit'     : this.credit,
                'payment_type' : this.payment_type.id ? this.payment_type.id : null,
                'status'     : this.status.id ? this.status.id : null,
            };

            let result = '';

            if(this.account_uuid === ''){
                data_send.payment_type = 'after';
                result = await this.$store.dispatch('accounts/FETCH_ACCOUNTS_CREATE', data_send);
            } else {
                data_send.uuid = this.account_uuid;
                result = await this.$store.dispatch('accounts/FETCH_ACCOUNTS_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Users.Accounts'});
            }
        }
	}
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />

        <b-form
            class="form-horizontal"
            @submit.prevent="saveUser"
        >

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">

                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Номер"
                                        label-for="number"
                                    >
                                        <b-form-input
                                            id="number"
                                            v-model="number"
                                            placeholder="Укажите номер аккаунта"
                                        ></b-form-input>
                                    </b-form-group>

                                    <!-- <b-form-group
                                        label="Компания"
                                        label-for="company"
                                    >
                                        <multiselect
                                            id="company"
                                            v-model="company"
                                            :options="company_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                            :track-by="trackBy"
                                        ></multiselect>
                                    </b-form-group> -->

                                    <b-form-group
                                        label="Пользователь"
                                        label-for="user"
                                    >
                                        <multiselect
                                            id="user"
                                            v-model="user"
                                            :options="users_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                            :track-by="trackBy"
                                        ></multiselect>
                                    </b-form-group>
                                    
                                    <b-form-group
                                        label="Тариф"
                                        label-for="tariff"
                                    >
                                        <multiselect
                                            id="tariff"
                                            v-model="tariff"
                                            :options="tariffs_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                            :track-by="trackBy"
                                        ></multiselect>
                                    </b-form-group>
                                    
                                    <b-form-group
                                        label="Тип аккаунта"
                                        label-for="payment_type"
                                    >
                                        <multiselect
                                            id="payment_type"
                                            v-model="payment_type"
                                            :options="payment_type_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                            :track-by="trackBy"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        v-if="payment_type && payment_type.id && payment_type.id === 'after'"
                                        label="Кредитный лимит"
                                        label-for="credit"
                                    >
                                        <b-form-input
                                            id="credit"
                                            v-model="credit"
                                            placeholder="0.00"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Статус"
                                        label-for="status"
                                    >
                                        <multiselect
                                            id="status"
                                            v-model="status"
                                            :options="status_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                            :track-by="trackBy"
                                        ></multiselect>
                                    </b-form-group>

                                </div>
                            </div>

                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->

        </div>

        </b-form>
	</Layout>
</template>
